// extracted by mini-css-extract-plugin
export default {"Aside":"aside_Aside__d1Nzk"};